export function flatFolderTree(state) {
  let flattened = []

  let traverse = function (children, prefix = '', level = 1) {
    _.forEach(children, function (child) {
      let title = prefix + ' ' + child.attributes.title
      flattened.push({
        title: child.attributes.title,
        prefixedTitle: title.trim(),
        uuid: child.uuid,
        level: level,
      })

      if (child.tree) {
        traverse(child.tree.data, prefix + '-', level + 1)
      }
    })
  }

  traverse(state.document.folders.data)

  return flattened
}

export function documentGetPendingDocumentShareCount(state) {
  return state.document.pendingShareCounts.documents
}

export function documentGetPendingFolderShareCount(state) {
  return state.document.pendingShareCounts.folders
}